module.exports = __webpack_public_path__ + "register-bg.e0cb579.jpg";